// extracted by mini-css-extract-plugin
module.exports = {"heading":"FeatureCardChoice_heading__iJMt4"};